export const mapTilerApiKey = 'tgTcMGqxNM1OlFkiZLOT';
